module.exports = "<i class=\"far fa-arrow-alt-circle-up\"></i>\n<i class=\"fab fa-amazon\"></i>\n<i class=\"fas fa-camera-retro\"></i>\n"